import React, { Component } from 'react';
import _ from 'lodash';

class HighlighProductModal extends Component {

    constructor(props) {
        super(props);

        const { products, highlightProduct } = props;

        let displayProduct = null;
        if (highlightProduct && highlightProduct.product_id) {
            displayProduct = products[highlightProduct.product_id];
            displayProduct['productId'] = highlightProduct.product_id;
        }

        this.state = {
            product: displayProduct,
            imageFile: null
        }
    }

    componentWillReceiveProps(nextProps) {

        const { products, highlightProduct } = nextProps;

        let displayProduct = null;
        if (highlightProduct && highlightProduct.product_id) {
            displayProduct = products[highlightProduct.product_id];
            displayProduct['productId'] = highlightProduct.product_id;
        }

        this.setState({
            product: displayProduct
        });
    }

    onProductDropdownClick(product, key) {
        this.setState({ product: { ...product, productId: key } });
    }

    onFileChooserChange(e) {
        const files = e.target.files;

        if (files.length > 0) {
            this.setState({ imageFile: files[0] });
        }
        console.log(files);
    }

    onSubmitButtonClick() {
        const { imageFile, product } = this.state;

        console.log(product);

        if (imageFile && product) {
            const { onAdd } = this.props;
            onAdd(imageFile, product.productId);
        }
    }

    renderProductsDropdown() {
        const { product } = this.state;
        const { products } = this.props;

        const rows = _.map(products, (product, key) => {
            return (
                <li key={key}>
                    <a
                        className="dropdown-item"
                        onClick={() => this.onProductDropdownClick(product, key)}
                    >
                        {product.name_en}
                    </a>
                </li>
            );
        });

        return (
            <div className="form-group select-dropdown">
                <label htmlFor="dropdown">Product:</label>
                <div className="form-group dropdown form-dropdown">
                    <button
                        className="btn dropdown-toggle form-list selected"
                        type="button"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                    >
                        {product ? product.name_en : 'Select a Product'}
                    </button>
                    <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                        {rows}
                    </ul>
                </div>
            </div>
        );
    }

    render() {
        const { onCancel, highlightProduct, products } = this.props;
        const { imageFile } = this.state;

        return (
            <div className="modal-body">
                <form onSubmit={(e) => e.preventDefault()}>
                    <h3>Add Highlight Product</h3>
                    {this.renderProductsDropdown()}
                    <div className="form-group browse-file">
                        <label htmlFor="custom-file">Image:
                                <span>(Recommend 2:1 e.g., 1200x600px)</span>
                        </label>
                        <label className="custom-file">
                            <input
                                type="file"
                                id="file2"
                                className="custom-file-input"
                                accept="image/*"
                                onChange={this.onFileChooserChange.bind(this)}
                            />
                            <span className="custom-file-control">
                                {imageFile ? imageFile.name : null}
                            </span>
                        </label>
                    </div>
                    <div className="modal-botton">
                        <button
                            className="btn button gray-btn"
                            onClick={onCancel}
                        >Cancel</button>
                        <button
                            className="btn button green-btn"
                            onClick={() => this.onSubmitButtonClick()}
                        >Add Highlight</button>
                    </div>
                </form>
            </div>
        )
    }
}

export default HighlighProductModal;


// WEBPACK FOOTER //
// ./src/views/products/HighlightProductModal.js